export default "/_next/static/images/body-c7d3d1b089f640885f79e6cd3b911d9d.png";